import { useContext } from 'react';
import { FloatingWindowType } from 'types/app.types';
import FloatingWindowsContext from 'contexts/FloatingWindowsContext';
import ProductsWindow from '../../../../FloatingWindowsSystem/components/ProductsWindow';
import Map from '../../../../Map';
import Window from '../../../../../../../../../../../components/Window';

interface SingleTileViewProps {
    className?: string,
    index: number
}

function SingleTileViewWindow({ className, index } : SingleTileViewProps) {
  const { floatingWindowsList } = useContext(FloatingWindowsContext);

  return (
    <>
      {floatingWindowsList
        .filter(({ type }) => type === FloatingWindowType.Products)
        .map(({ title }) => (
          <Window
            title={title}
            key={index}
            render={() => <ProductsWindow />}
          />
        ))}
      <Map />
    </>
  );
}

export default SingleTileViewWindow;
